export default __webpack_public_path__ + "static/media/sym-check.8596de3e.svg";